var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.625 3.25L13.625 6.41468M6.37501 3.25L6.375 6.41468M2.78643 9.69445L17.25 9.69445M4.39752 4.80358H15.6389C16.5287 4.80358 17.25 5.5249 17.25 6.41469L17.25 16.1389C17.25 17.0287 16.5287 17.75 15.6389 17.75L4.39754 17.75C3.50774 17.75 2.78643 17.0287 2.78643 16.1389L2.75 6.29961C2.75 5.40982 3.50773 4.80358 4.39752 4.80358Z",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateIcon);
export default __webpack_public_path__ + "14cf1e20b1f560c903cd33881eb37343.svg";
export { ForwardRef as ReactComponent };